export const Actions = {
  SET_WORKITEMSUBSCRIPTION: 'SET_WORKITEMSUBSCRIPTION',
};

export const setWorkItemSubscription = (payload: any) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_WORKITEMSUBSCRIPTION,
    payload,
  });
};
